import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Clients from './components/Clients';
import Work from './components/Work';
import Services from './components/Services';
import Ai from './components/Ai';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Locations from './components/Locations';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import CaseStudy from './components/CaseStudy';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import NotFound from './components/NotFound';
import { HomeSeo } from './components/Seo';

function Home() {
  const { hash } = useLocation();

  // Preserve anchor-link (#work, #services, …) behaviour under BrowserRouter.
  // Native <a href="#work"> clicks already work in-place, but when navigating
  // back to "/" with a hash (e.g. from a case study back link or a deep load),
  // the Home route mounts fresh and we must scroll to the target ourselves.
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      // Defer until after paint so the element is laid out.
      requestAnimationFrame(() => el.scrollIntoView());
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <>
      <HomeSeo />
      <Navigation />
      <main>
        <Hero />
        <Clients />
        <Work />
        <Services />
        <Ai />
        <About />
        <Testimonials />
        <Locations />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work/:slug" element={<CaseStudy />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/de" element={<Home />} />
        <Route path="/de/work/:slug" element={<CaseStudy />} />
        <Route path="/de/impressum" element={<Impressum />} />
        <Route path="/de/datenschutz" element={<Datenschutz />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BackToTop />
    </>
  );
}
